import { useTranslation } from 'next-i18next'
import { Box, Heading, Text } from '@machobear/design-system'

import { AlertButtonList } from '@/features/Listings/buttons'

const EmptyState = () => {
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginY="xxxlarge"
      paddingY="gutter"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="medium"
        paddingBottom="xxxlarge"
        style={{ maxWidth: '324px' }}
        textAlign="center"
      >
        <Heading level="4" component="h2" weight="weak">
          {t(
            'filters:b.listings.view.map_no_results.title',
            'Good Listings Go Fast!'
          )}
        </Heading>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="large"
        >
          <Text size="standard" align="center">
            {t(
              'filters:b.listings.view.map_no_results.text',
              'Create a listing alert to be the first to know when new listings become available.'
            )}
          </Text>
          <AlertButtonList primary hideOnMobile={false} />
        </Box>
      </Box>
    </Box>
  )
}

export default EmptyState
